import { Select } from "@rio-cloud/rio-uikit";
import { useIntl } from 'react-intl';
import SelectCustom from '../../../../components/selectCustom';
import { IDnOptionItens } from '../../../../models/newSupportCall';

interface SupportCallDnFieldProps {
    dn?: string;
    error?: string;
    role: string;
    dnOptions: IDnOptionItens[];
    getAllDns: (searchTerm: string, pageSize: number, page: number) => Promise<Array<{ id: string; label: string }>>;
    onChange: (value: string) => void;
}

const SupportCallDnField = ({ dn, error, role, dnOptions, getAllDns, onChange }: SupportCallDnFieldProps) => {
    const intl = useIntl();
    const shouldUseSearchSelect = role === 'TOWER' || role === 'FACTORY';

    return (
        <div className='form-group form-group-lg flex-1-1'>
            <label className='text-size-14 text-color-darker'>{intl.formatMessage({ id: 'intl-msg:support.supportCallDnField.dn' })}*</label>
            {shouldUseSearchSelect ? (
                <SelectCustom
                    value={[dn || '']}
                    onChange={(item) => { onChange(item?.id || '') }}
                    loadData={getAllDns}
                    disabled={false}
                    isRemoved={false}
                    loadOnFocus={true}
                    openOnFocus={false}
                    autoFocus={false}
                    initialLimit={10}
                    placeholder={intl.formatMessage({ id: 'intl-msg:support.supportCallDnField.searchPlaceholder' })}
                />
            ) : (
                <Select
                    bsSize='lg'
                    value={dn ? [dn] : []}
                    onChange={option => onChange(option?.id || '')}
                    options={dnOptions?.map(dnItem => ({ id: dnItem.value, label: dnItem.label }))}
                    placeholder={intl.formatMessage({ id: 'intl-msg:tas.support.toolbar.selectPlaceholder' })}
                />
            )}
            <div className="height-15">
                {error ? <span className='text-size-12 text-color-danger'>{error}</span> : null}
            </div>
        </div>
    );
};

export default SupportCallDnField;
